/** Puts each answer's conditions next to each other, in the order each answer first appears. */
export function groupConditionsByValue<T extends { value: string }>(conditions: T[]): T[] {
    const groups = new Map<string, T[]>();
    for (const condition of conditions) {
        const key = String(condition.value);
        const group = groups.get(key);
        if (group) {
            group.push(condition);
        } else {
            groups.set(key, [condition]);
        }
    }
    return [...groups.values()].flat();
}
